var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-section"},[_c('h4',[_c('FontAwesomeIcon',{attrs:{"icon":['far', _vm.icon ]}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")],1),_vm._v(" "),_c('div',{class:{'is-indented': _vm.isIndented}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3095fffa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailSection.vue
// module id = 717
// module chunks = 0